customElements.define(

  "cc-product-auto-grid", 

  class extends HTMLElement{

    connectedCallback(){

        let gap = this.getAttribute("gap");
        let padding = this.getAttribute("padding");
        const element = this.innerHTML;
  

        if( gap == "" ){
            gap = "1em";
        }
        if( padding == "" ){
            padding = "1em";
        }
        let spacing = `style="gap:${gap};padding:${padding};"`;

        this.innerHTML = `
        <div class="cc-product-auto-grid">

            <div class="cc-product-auto-grid__grid" ${spacing}>

                ${element}

            </div>

        </div>      

        `;



    }
       
  }

);